<script setup>
import dayjs from 'dayjs';
import { onMounted } from 'vue';

const props = defineProps({
  compromisso: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['loaded']);

onMounted(() => {
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    :column="3"
    :label-style="{ width: '15%' }"
    bordered
  >
    <a-descriptions-item
      label="Possível encerrar?"
      :span="3"
    >
      {{ props.compromisso.data?.possivelEncerrar ? 'Sim' : 'Não' }}
    </a-descriptions-item>

    <template v-if="props.compromisso.data?.possivelEncerrar">
      <a-descriptions-item
        label="Motivo"
        :span="3"
      >
        {{ props.compromisso.data?.motivoText }}
      </a-descriptions-item>

      <a-descriptions-item
        label="Data do Registro"
        :span="3"
      >
        {{ props.compromisso.data?.dataRegistro ? dayjs(props.compromisso.data.dataRegistro).format('DD/MM/YYYY HH:mm') : '' }}
      </a-descriptions-item>

      <a-descriptions-item
        label="Observação"
        :span="3"
      >
        {{ props.compromisso.data?.observacao }}
      </a-descriptions-item>
    </template>

    <template v-else>
      <a-descriptions-item
        label="Justificativa"
        :span="3"
      >
        {{ props.compromisso.data?.justificativa }}
      </a-descriptions-item>
    </template>
  </a-descriptions>
</template>
